import React from 'react';
import clsx from 'clsx';
import { Tooltip, TooltipProps } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';

type WrapperProps = { children: React.ReactNode };

const PopoverChildrenWrapper = React.forwardRef<HTMLDivElement, WrapperProps>(
  function Wrapper(props, ref) {
    return <div {...props} ref={ref} />;
  }
);

const useStyles = makeStyles<JupiterTheme>((theme) =>
  createStyles({
    root: {
      display: 'flex',
      color: 'white',
      backgroundColor: theme.palette.grey[800],
      zIndex: theme.zIndex.drawer + 2,
      borderRadius: 0,
      marginTop: theme.spacing(2.5),
      maxWidth: 'none',
    },
    arrow: {
      fontSize: '1.75rem', // Size of the arrow
      '&::before': {
        backgroundColor: theme.palette.grey[800],
      },
    },
  })
);

export interface PopoverProps {
  open?: boolean;
  content: React.ReactNode | string;
  className?: string;
  children?: React.ReactNode;
  placement?: TooltipProps['placement'];
}
const Popover = ({
  open,
  content,
  children,
  placement,
  className,
}: PopoverProps) => {
  const classes = useStyles();

  return (
    <Tooltip
      classes={{ tooltip: clsx(classes.root, className), arrow: classes.arrow }}
      open={open}
      title={<>{content}</>}
      placement={placement}
      interactive
      arrow
    >
      <PopoverChildrenWrapper>{children}</PopoverChildrenWrapper>
    </Tooltip>
  );
};

export default Popover;
